import type { Template } from "@amzn/d16-g-cdb-publisher-portal-typescript-client";

import type { Deck } from "./publisherPortal.utils";

export const sortDecks = (decks: Deck[]): Deck[] => {
    return decks.sort((a, b) =>
        a.recommended === b.recommended
            ? a.name!.localeCompare(b.name!)
            : a.recommended
              ? -1
              : 1,
    );
};

export const sortTemplates = (templates: Template[]): Template[] => {
    return templates.sort((a, b) => (a.name!.localeCompare(b.name!) ? 1 : -1));
};
